import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../../authentication/authentication.service';
import { AuthDispatcher } from '../../../store/auth/auth-dispatcher';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../../store/state.model';

/** Creates custom http calls get or post */
export class CustomHttpParams extends HttpParams {
  constructor(public spec: string) {
    super({ fromObject: { spec: spec } });
  }
}
/** Handles the Api calls with the body or header deired
 * allow the client perform custom logic on the error/succes payloads
 */
@Injectable()
export class AdminApiHandlerService extends HttpClient {
  /**
  * @var This property will host the value of the enviroment where needs to be done the API/Endpoint call
  **/
  private environment: string;

  /**
  * @var This property will determine the type of the api call
  **/
  private requestType: string;
  constructor(
    private httpHandler: HttpHandler,
    private authService: AuthenticationService,
    private authDispatcher: AuthDispatcher,
    public reduxState: NgRedux<AppState>,
    public router: Router,
    public translate: TranslationService,
    public ngRedux: NgRedux<AppState>
  ) {
    super(httpHandler);
  }

  /**
  * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
  * @returns The response that is being intercepted so it can continue to the Network call
  **/
  getTypeParams() {
    return (!!this.requestType) ?
      new CustomHttpParams(this.requestType) : new CustomHttpParams('default');
  }
  /** This method posts a request to the passed url, body and options */
  postRequest(url: string, body: any | null, options?: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    const env = this.environment;
    return super.post(`${env}${url}`,
      !!body ? Object.assign(body) : '',
      { headers: headers, params: this.getTypeParams() }
    ).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }

  /** This method posts a request to the passed url, body and options */
  putRequest(url: string, body: any | null, options?: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    const env = this.environment;
    return super.put(`${env}${url}`, Object.assign(body), {
      headers: headers,
      params: this.getTypeParams()
    }).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }

  /** This method gets a request to the passed url and options */
  getRequest(url: string, options?: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    const env = this.environment;
    return super.get(`${env}${url}`, {
       headers: headers,
       params: this.getTypeParams()
     }).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }

  /** This method sends a delete request to the passed url, body and options */
  patchRequest(url: string, body: any | null, options?: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    const env = this.environment;
    return super.patch(`${env}${url}`, Object.assign(body), {
      headers: headers,
      params: this.getTypeParams()
    }).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }

  /** This method sends a delete request to the passed url, body and options */
  deleteRequest(url: string, body: any | null, options?: any): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    const env = this.environment;
    return super.request('delete', `${env}${url}`, {
      headers: headers,
      body,
      params: this.getTypeParams()
    }).pipe(
      map((res: any) => {
        return (res);
      }),
      catchError(this.handleError.bind(this))
    );
  }

  /** This method adds the custom headers taken from the user input to the http request */
  getHeaders(data: { type: string, params: any }): HttpHeaders {
    this.environment = environment.svpp_gateway;
    this.requestType = (!!data && !!data.type) ? data.type : 'default';
    let headers = new HttpHeaders();
    const timestamp = Date.now();
    if (!!data.params) {
      if (!!data.params.gen && data.params.gen === 'GR86') {
        headers = headers.set('x-guid', data.params['x-guid']);
      }
    }
    headers = headers.set('Content-Type', 'application/json');
    const token = this.ngRedux.getState().auth.token;
    if (!!data && !!data.params) {
      const params = data.params;
      switch (data.type) {
        case 'acm':
          this.environment = environment.adminportal_GW;
          headers = !!params.brand ? headers.set('x-brand', ['TOY', 'T', 'TOYOTA'].indexOf(params.brand) > -1 ? 'T' : ['SUB', 'S', 'SUBARU'].indexOf(params.brand) > -1 ? 'S' : 'L') : headers.set('x-brand', 'T');
          break;
        case 'acm-dealer':
          this.environment = environment.adminportal_GW;
          headers = (!!params.phone) ? headers.set('phone', params.phone) :
            !!params.guid ? headers.set('guid', params.guid) :
              headers.set('Email', params.email);
          break;
        case 'vehicle-history':
          this.environment = environment.adminportal_GW;
          break;
        case 'vehicle_list':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('VIN', params.vin) : headers;
          headers = !!params.guid ? headers.set('X-GUID', params.guid) : headers;
          headers = !!params.brand ? headers.set('x-brand', ['TOY', 'T', 'TOYOTA'].indexOf(params.brand) > -1 ? 'T' : ['SUB', 'S', 'SUBARU'].indexOf(params.brand) > -1 ? 'S' : 'L') : headers;
          headers = !!params.generation ? headers.set('generation', params.generation) : headers;
          break;
        case 'remote-command':
          headers = !!params.vin ? headers.set('VIN', params.vin) : headers;
          break;
        case 'remote-command-24mm':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = headers.set('generation', !!params.generation ? params.generation : 'UNKNOWN');
          break;
        case 'cvs_details':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = headers.set('language', this.getLanguage());
          break;
        case 'plug_and_charge':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.brand ? headers.set('x-brand', params.brand) : headers;
          headers = !!params.region ? headers.set('x-region', params.region) : headers;
          break;
        case 'hu-company':
          const { email, modelCode, modelName, mpc, mpcOption, year } = params;
          headers = headers.set('modelCode', !!modelCode ? modelCode : 'UNKNOWN');
          headers = headers.set('modelName', !!modelName ? modelName : 'UNKNOWN');
          headers = headers.set('mpc', !!mpc ? mpc : 'UNKNOWN');
          headers = headers.set('mpcOption', !!mpcOption ? mpcOption : 'UNKNOWN');
          headers = headers.set('year', !!year ? year : 'UNKNOWN');
          headers = headers.set('headUnitConfigArray', ['1', '2']);
          break;
        case 'preview':
          const { asicode, hwType, generation, region, brand, vin, guid } = params;
          headers = headers.set('asi-code', !!asicode ? asicode : 'UNKNOWN');
          headers = headers.set('hw-type', !!hwType ? hwType : 'UNKNOWN');
          headers = headers.set('generation', !!generation ? generation : 'UNKNOWN');
          headers = headers.set('region', !!region ? region : 'UNKNOWN');
          headers = headers.set('X-BRAND', !!brand ? brand : 'UNKNOWN');
          headers = headers.set('Language', this.getLanguage());
          headers = headers.set('vin', !!vin ? vin : 'UNKNOWN');
          headers = headers.set('guid', !!guid ? guid : 'UNKNOWN');
          break;
        case 'subscription-history':
        case 'provision-history':
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.guid ? headers.set('guid', params.guid) : headers;
          headers = headers.set('page', params.page !== undefined && params.page !== null ? params.page.toString() : '1');
          headers = headers.set('size', params.limit !== undefined && params.limit !== null ? params.limit.toString() : '10');
          break;
        case 'customer-history':
          headers = !!params.email ? headers.set('email', params.email) : headers;
          headers = headers.set('pageNo', params.pageNo ? params.pageNo.toString() : '1');
          headers = headers.set('pageSize', params.pageSize ? params.pageSize.toString() : '10');
          break;
        case 'navi':
          headers = headers.set('X-BRAND', !!params.brand ? params.brand : 'UNKNOWN');
          break;
        case 'delete-account':
          this.environment = environment.adminportal_GW;
          headers = !!params.brand ? headers.set('x-brand', ['TOY', 'T', 'TOYOTA'].indexOf(params.brand) > -1 ? 'T' : ['SUB', 'S', 'SUBARU'].indexOf(params.brand) > -1 ? 'S' : 'L') : headers;
          headers = !!params.guid ? headers.set('guid', params.guid) : headers;
          break;
        case 'unlink-vehicle':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.brand ? headers.set('x-brand', ['TOY', 'T', 'TOYOTA'].indexOf(params.brand) > -1 ? 'T' : ['SUB', 'S', 'SUBARU'].indexOf(params.brand) > -1 ? 'S' : 'L') : headers;
          break;
        case 'acm-cu':
          this.environment = environment.adminportal_GW;
          headers = headers.set('x-generation', !!params.generation ? params.generation : '17CYPLUS');
          headers = headers.set('x-vehiclebrands', !!params.vehiclebrands ? params.vehiclebrands : '');
          break;
        case 'att-wifi-status':
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = headers.set('x-guid', 'testadmintestadmintestadmintestt');
          break;
        case 'get-provisioning':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.correlationId ? headers.set('x-correlationid', params.correlationId) : headers;
          headers = !!params.authorization ? headers.set('Authorization', params.authorization) : headers;
          break;
        case 'update-emergency-contact':
          this.environment = environment.adminportal_GW;
          headers = headers.set('X-BRAND', !!params.brand ? params.brand : 'UNKNOWN');
          headers = headers.set('X-generation', !!params.brand ? params.generation : 'UNKNOWN');
          headers = headers.set('X-region', !!params.brand ? params.region : 'UNKNOWN');
          headers = headers.set('datetime', timestamp.toString());
          break;
        case 'emergency-contact':
          this.environment = environment.adminportal_GW;
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = headers.set('x-guid', !!params.guid ? params.guid : 'UNKNOWN');
          headers = headers.set('x-brand', !!params.brand ? params.brand : 'UNKNOWN');
          headers = headers.set('x-generation', !!params.brand ? params.generation : 'UNKNOWN');
          headers = headers.set('x-region', !!params.brand ? params.region : 'UNKNOWN');
          break;
        case 'get-zuora-information':
          headers = !!params.guid ? headers.set('guid', params.guid) : headers;
          break;
        case 'cms-request-group-id':
          headers = !!params.requestId ? headers.set('request-id', params.requestId) : headers;
          break;
        case 'cms-request-group-fields':
          headers = !!params.requestId ? headers.set('group-id', params.requestId) : headers;
          break;
        case 'cms-create-ticket':
          this.environment = environment.adminportal_GW;
          headers = !!params.attachment ? headers.set('attachment', params.attachment) : headers;
          break;
        case 'phone-compatibility':
          headers = !!params.huConfigId ? headers.set('huConfigId', String(params.huConfigId)) : headers;
          headers = !!params.phoneConfigId ? headers.set('phoneConfigId', String(params.phoneConfigId)) : headers;
          break;
        case 'guid-status':
          headers = headers.set('email', params.email);
          break;
        case 'sendCode':
          headers = (!!params.brand) ? headers.set('X-BRAND', params.brand) : headers;
          break;
        case 'auth_remote_legacy':
          headers = (!!params.guid) ? headers.set('x-guid', params.guid) : headers;
          headers = (!!params.vin) ? headers.set('vin', params.vin) : headers;
          headers = (!!params.brand) ? headers.set('X-BRAND', params.brand) : headers;
          break;
        case 'preferred-dealer':
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = !!params.guid ? headers.set('x-guid', params.guid) : headers;
          headers = !!params.region ? headers.set('x-region', params.region) : headers;
          headers = params.region === 'CA' ? headers.set('x-brand', params.brand) : headers;
          break;
        case 'home-dealer':
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = !!params.guid ? headers.set('x-guid', params.guid) : headers;
          headers = !!params.region ? headers.set('region', params.region) : headers;
          break;
        case 'product-packages':
          headers = headers.set('asi-code', !!params.asicode ? params.asicode : 'UNKNOWN');
          headers = headers.set('hw-type', !!params.hwType ? params.hwType : 'UNKNOWN');
          headers = headers.set('generation', !!params.generation ? params.generation : 'UNKNOWN');
          headers = headers.set('region', !!params.region ? params.region : 'UNKNOWN');
          headers = headers.set('brand', !!params.brand ? params.brand : 'UNKNOWN');
          headers = headers.set('Language', this.getLanguage());
          break;
        case 'trial-lengths':
          this.environment = environment.adminportal_GW;
          headers = headers.set('ASI-CODE', params.asiCode || 'UNKNOWN');
          headers = headers.set('generation', params.generation || 'UNKNOWN');
          headers = headers.set('HW-TYPE', params.hardwareType || 'UNKNOWN');
          headers = headers.set('region', params.region || 'UNKNOWN');
          headers = headers.set('x-brand', params.brand || 'UNKNOWN');
          headers = headers.set('huVersion', params.huVersion || 'UNKNOWN');
          headers = headers.set('dcmModelYear', params.dcmModelYear || 'UNKNOWN');
          headers = headers.set('modelYear', params.modelYear || 'UNKNOWN');
          break;
        case 'survivor-account':
          headers = !!params.brand ? headers.set('x-brand', ['TOY', 'T', 'TOYOTA'].indexOf(params.brand) > -1 ? 'T' : ['SUB', 'S', 'SUBARU'].indexOf(params.brand) > -1 ? 'S' : 'L') : headers.set('x-brand', 'T');
        case 'linked-accounts-21mm':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          break;
        case 'register-vehicle-21mm':
          headers = !!params.guid ? headers.set('X-GUID', params.guid) : headers;
          headers = !!params.guid ? headers.set('x-hucom', '(' + params.brand + ';' + params.vin + ';' + params.imei + ';' + params.region + ')') : headers;
          break;
        case 'give-goodwill':
          headers = headers.set('asi-code', !!params.asicode ? params.asicode : 'UNKNOWN');
          headers = headers.set('hw-type', !!params.hwType ? params.hwType : 'UNKNOWN');
          headers = headers.set('generation', !!params.generation ? params.generation : 'UNKNOWN');
          headers = headers.set('region', !!params.region ? params.region : 'UNKNOWN');
          headers = headers.set('x-brand', !!params.brand ? params.brand : 'UNKNOWN');
          headers = headers.set('guid', !!params.guid ? params.guid : 'UNKNOWN');
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = headers.set('Language', this.getLanguage());
          break;
        case 'submit-goodwill':
          headers = headers.set('x-brand', !!params.brand ? params.brand : 'UNKNOWN');
          break;
        case 'data-consents':
          this.environment = environment.adminportal_GW;
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = !!params.guid ? headers.set('guid', params.guid) : headers;
          headers = headers.set('x-brand', !!params.brand ? params.brand : 'UNKNOWN');
          break;
        case 'sms-consent':
          this.environment = environment.adminportal_GW;
          headers = !!params.guid ? headers.set('guid', params.guid) : headers;
          headers = headers.set('x-brand', params.brand || '');
          headers = headers.set('x-locale', params.locale || 'en-US');
          break;
        case 're-sync-settable-flags':
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.vin ? headers.set('x-call-tsc-settable-apis', params.reSyncSettableFlags) : headers;
          headers = headers.set('language', this.getLanguage());
          break;
        case 'update-remote-user':
          headers = (!!params.brand) ? headers.set('x-brand', params.brand) : headers;
          break;
        case 'get-vehicle-association':
          headers = headers.set('vin', !!params.vin ? params.vin : 'UNKNOWN');
          headers = headers.set('x-brand', !!params.brand ? params.brand : 'UNKNOWN');
          break;
        case 'rental-summary':
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.guid ? headers.set('guid', params.guid) : headers;
          break;
        case 'userprofile-21mm':
          this.environment = environment.adminportal_GW;
          headers = !!params.vin ? headers.set('vin', params.vin) : headers;
          headers = !!params.brand ? headers.set('x-brand', params.brand) : headers;
          break;
        case 'tss-request':
          // Service status endpoint - uses SVPP gateway for telematics service queries
          // The CmsHeaderInterceptorService will add x-channel and x-correlationid headers
          break;

      }
    }
    return headers;
  }
  /** This method returns the language header for the  preview api*/
  getLanguage(): string {
    const lang = this.translate.getCurrentLanguage();
    return lang.includes('en') ? 'en-US' : lang.includes('fr') ? 'fr-CA' : 'es-PR';
  }
  /** This method handles the errors of a http request*/
  handleError(err: HttpErrorResponse): Observable<ArrayBuffer> {
    if (!(err instanceof HttpErrorResponse)) {
      return throwError(() => ({ success: false, errorCode: undefined, errorMessage: String(err), api: '' }));
    }
    if (this.isAuthenticationError(err)) {
      return throwError(() => ({ errorCode: 'UNAUTHORIZED' }));
    }
    const hasContent = this.checkErrorContent(err);
    const errorCode = hasContent && err.error.status.messages.map(error => error.responseCode);
    const errorMessage = hasContent && err.error.status.messages.map(error => error.detailedDescription);
    const throwObj = (!!errorCode && errorCode.length) ? errorCode : [err.status];
    const url = hasContent ? err.url : '';
    let errorResponse = { 'success': false, errorCode: throwObj[0], errorMessage: errorMessage && errorMessage[0], api: url ? url.split(this.environment)[1] : '' };
    if ((!!errorCode &&
      (errorCode.indexOf('OCPR-0011') > -1))
      && this.requestType === 'acm-dealer') {
      errorResponse = Object.assign({ 'customerFound': false }, errorResponse);
    }
    return throwError(() => errorResponse);
  }
  /** This method determines if it is an authentication error from the api gateway*/
  isAuthenticationError(err: HttpErrorResponse): boolean {
    const hasContent = this.checkErrorContent(err);
    const firstMessage = hasContent && err.error.status.messages[0];
    const isExpired = !!firstMessage && !!firstMessage.detailedDescription && firstMessage.detailedDescription.toLowerCase().indexOf('expired') > -1;
    const isApigw403 = err.status === 403 && !!firstMessage && firstMessage.responseCode === 'APIGW-403';
    const isUnknownNetworkError = err.status === 0 && err.ok === false && (err.statusText === 'Unknown Error' || !err.statusText);
    if (isExpired || isApigw403) {
      this.routeError();
      this.authDispatcher.logout();
      return true;
    }
    if (isUnknownNetworkError) {
      return false;
    }
    return false;
  }
  /** This checks the structure of the error if there is a status object*/
  checkErrorContent(err: HttpErrorResponse): boolean {
    return !!(err.error && err.error.status && err.error.status.messages && err.error.status.messages.length);
  }
  /*
  * @function routeError routes to error page
  * @returns void
  **/
  private routeError(): void {
    this.router.navigate(['dashboard/error'], { queryParams: {}, skipLocationChange: true });
  }
}
